import { Container, ContainerProps } from '@components/Layout/Container';
import { HideSidebar } from '@components/Layout/HideSidebar';
import { Row, RowProps } from '@components/Layout/Row';
import { ShowSidebar } from '@components/Layout/ShowSidebar';
import { PaperProps } from '@material-ui/core/Paper';
import { IF } from '@packages/react/lib/if';
import React, { ReactElement } from 'react';
import { useHeaderElevation } from './hooks/useHeaderElevation';
import { usePageTitle } from './hooks/usePageTitle';

interface LayoutProps extends RowProps {
    title?: string;
    pageTitle?: string;
    background?: string;
    headerElevation?: PaperProps['elevation'];
    noPadding?: boolean;
    container?: boolean;
    noSidebar?: boolean;
    containerProps?: ContainerProps;
    direction?: string;
    align?: string;
}

export function Layout(props: LayoutProps): ReactElement {
    const {
        title,
        pageTitle,
        noPadding,
        headerElevation,
        background,
        noSidebar,
        container,
        containerProps,
        direction = 'column',
        align = 'center',
        ...rest
    } = props;

    useHeaderElevation(headerElevation);
    usePageTitle(title || pageTitle);

    rest.style = {
        width: '100%',
        height: '100%',
        backgroundColor: background,

        ...(rest.style || {}),
    };

    if (!noPadding) {
        rest.padding = '0 0 0';
    }

    if (container) {
        rest.children = (
            <Container responsive {...containerProps}>
                {rest.children}
            </Container>
        );
    }

    rest.children = (
        <>
            {IF(!noSidebar, <ShowSidebar />, <HideSidebar />)}
            {rest.children}
        </>
    );

    return <Row layout={direction} align={align} justify={'start'} {...rest} />;
}

Layout.defaultProps = {
    noSidebar: false,
    containerProps: {},
};
